import { render } from "./list.html?vue&type=template&id=4aaf0350&ts=true&external"
import script from "./list.ts?vue&type=script&lang=ts&external"
export * from "./list.ts?vue&type=script&lang=ts&external"

import "./list.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__